import type { FC, SVGProps } from 'react';

import CupStarBoldIcon from '@/shared/assets/icons/cup-star-bold.svg?react';
import CupStarLinearIcon from '@/shared/assets/icons/cup-star-linear.svg?react';
import GamepadBoldIcon from '@/shared/assets/icons/gamepad-bold.svg?react';
import GamepadLinearIcon from '@/shared/assets/icons/gamepad-linear.svg?react';
import UserCircleBoldIcon from '@/shared/assets/icons/user-circle-bold.svg?react';
import UserCircleLinearIcon from '@/shared/assets/icons/user-circle-linear.svg?react';
import WalletMoneyBoldIcon from '@/shared/assets/icons/wallet-money-bold.svg?react';
import WalletMoneyLinearIcon from '@/shared/assets/icons/wallet-money-linear.svg?react';
import { ROUTES } from '@/shared/config/constants';

export type FooterLabelKey = 'footer.games' | 'footer.top' | 'footer.wallet' | 'footer.profile';

export type FooterTab = {
  id: string;
  label: FooterLabelKey;
  iconActive: FC<SVGProps<SVGSVGElement>>;
  iconInactive: FC<SVGProps<SVGSVGElement>>;
  matchPaths?: string[];
  disabled?: boolean;
};

export const FOOTER_TABS: FooterTab[] = [
  {
    id: ROUTES.GAMES,
    label: 'footer.games',
    iconActive: GamepadBoldIcon,
    iconInactive: GamepadLinearIcon,
    matchPaths: [ROUTES.GAMES, ROUTES.ROLLS, ROUTES.JETTON, ROUTES.MINES, ROUTES.BALLOON],
  },
  {
    id: ROUTES.LEADERBOARD,
    label: 'footer.top',
    iconActive: CupStarBoldIcon,
    iconInactive: CupStarLinearIcon,
  },
  {
    id: ROUTES.SHOP,
    label: 'footer.wallet',
    iconActive: WalletMoneyBoldIcon,
    iconInactive: WalletMoneyLinearIcon,
    disabled: false,
  },
  {
    id: ROUTES.PROFILE,
    label: 'footer.profile',
    iconActive: UserCircleBoldIcon,
    iconInactive: UserCircleLinearIcon,
  },
];
